export default __webpack_public_path__ + "static/media/selecta_main.20d95a8a.jpg";